/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Day_ThuInputs */



/**
* | output |
* | --- |
* | "Thursday" |
*
* @param {Agent_Schedule_Day_ThuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_day_thu = /** @type {((inputs?: Agent_Schedule_Day_ThuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Day_ThuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Donnerstag")
	return /** @type {LocalizedString} */ ("Thursday")
});